import { render, staticRenderFns } from "./MainCmp.vue?vue&type=template&id=1a7b8f36&"
import script from "./MainCmp.vue?vue&type=script&lang=js&"
export * from "./MainCmp.vue?vue&type=script&lang=js&"
import style1 from "./MainCmp.vue?vue&type=style&index=1&id=1a7b8f36&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports